<template>
  <v-row justify="center" class="mt-4">
    <v-col cols="1" class="py-0 pt-7">
      <v-avatar color="primary" size="40" class="mt-n3 mr-3">
        <h6 class="white--text font-weight-bold step-number">{{ stepNumber }}</h6>
      </v-avatar>
    </v-col>

    <v-col cols="11" class="pl-8">
      <h6 class="step-title">{{ stepTitle }}</h6>
      <span class="step-sub-title font-weight-light">{{ stepSubTitle }}</span>
      <slot></slot>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'ClaimSwayOfferSection',

  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
    stepTitle: {
      type: String,
      required: true,
    },
    stepSubTitle: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.step-number {
  font-size: 26px;
}

.step-title {
  font-size: 20px;
  font-weight: 500;
}

.step-sub-title {
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
}
</style>
